import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import { ThemeSelectors } from '../../selectors/theme-selectors';
export var CardContainerStyles = function (interactive) {
    if (interactive === void 0) { interactive = true; }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: rgb(0 0 0 / 10%) 0 1px 5px 0;\n\n    ", "\n"], ["\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: rgb(0 0 0 / 10%) 0 1px 5px 0;\n\n    ", "\n"])), function (_a) {
        var theme = _a.theme;
        return ThemeSelectors.getGroupFourSpacing(theme);
    }, function (_a) {
        var theme = _a.theme;
        return ThemeSelectors.getWhite(theme);
    }, interactive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &:hover {\n            transform: translateY(-1px);\n            box-shadow: rgb(0 0 0 / 12%) 0 2px 8px 0;\n        }\n    "], ["\n        &:hover {\n            transform: translateY(-1px);\n            box-shadow: rgb(0 0 0 / 12%) 0 2px 8px 0;\n        }\n    "]))));
};
export var CardContainer = styled.article(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), function (_a) {
    var interactive = _a.interactive;
    return CardContainerStyles(interactive);
});
var templateObject_1, templateObject_2, templateObject_3;
